export default "__VITE_ASSET__CKNQrSUi__"